module.exports = "<p>\r\n\talgorithms works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/algorithms/algorithms/algorithms.component.html
// module id = ../../../../../src/app/packages/menu-items/algorithms/algorithms/algorithms.component.html
// module chunks = main